export function emailErrors(email: string): string | null {
  if (!email.trim().length) return 'email_required';
  if (!email.includes('@')) return 'email_missing_at';

  const parts = email.split('@');
  if (parts.length !== 2) return 'email_multiple_ats';

  const [local, domain] = parts;
  if (!local) return 'email_missing_local';
  if (!domain) return 'email_missing_domain';

  if (!domain.includes('.')) return 'email_domain_missing_dot';

  const domainParts = domain.split('.');
  if (domainParts.length !== 2) return 'email_domain_should_have_one_dot';

  const [, afterDot] = domainParts;

  if (!afterDot) return 'email_domain_missing_suffix';

  if (email.includes(',')) return 'email_should_not_have_comma';

  return null;
}
